import { DISCOVERY_TAB, type DiscoverySubView } from '@discovr/ui';

/** The admin view a brand campaign page links to: Discovery > Find creators. */
const ADMIN_DISCOVERY_SUB: DiscoverySubView = 'find';
const CAMPAIGN_PATH_PREFIX = '/campaign/';

/**
 * Where the brand app's "Open Admin" button points. On a campaign page it is
 * that campaign's discovery view in admin (both apps use the slug in the path);
 * anywhere else it is the admin origin. Null when admin is not configured.
 */
export function adminCampaignUrl(adminOrigin: string | null, pathname: string): string | null {
  if (!adminOrigin) return null;
  const slug = campaignSlugFromPath(pathname);
  if (!slug) return adminOrigin;
  const origin = adminOrigin.replace(/\/+$/, '');
  // The slug comes from the current URL path, so it is already percent-encoded.
  const params = new URLSearchParams({ tab: DISCOVERY_TAB, sub: ADMIN_DISCOVERY_SUB });
  return `${origin}${CAMPAIGN_PATH_PREFIX}${slug}?${params.toString()}`;
}

/** `/campaign/<slug>` exactly; nested or empty paths are not a campaign page. */
function campaignSlugFromPath(pathname: string): string | null {
  const parts = pathname.split('/').filter(Boolean);
  return parts.length === 2 && parts[0] === 'campaign' ? (parts[1] ?? null) : null;
}
